// Import models.
import BuildingResponseCommercial from './BuildingResponseCommercial';

export default class BuildingResponseCommercialExisting extends BuildingResponseCommercial {

	public id: string | null = null;

	public constructor() {
		super();
	}
}